import { render, staticRenderFns } from "./approveQuery.vue?vue&type=template&id=22e41704"
import script from "./approveQuery.vue?vue&type=script&lang=js"
export * from "./approveQuery.vue?vue&type=script&lang=js"
import style0 from "./approveQuery.vue?vue&type=style&index=0&id=22e41704&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports